<template>
  <section class="wp-box" :class="{ 'is-closed': !isOpen }">
    <button type="button" class="wp-box__head" :aria-expanded="isOpen ? 'true' : 'false'" @click="toggle">
      <span class="wp-box__title">{{ title }}</span>
      <slot name="badge" />
      <span class="wp-box__chev" aria-hidden="true">▾</span>
    </button>
    <div v-show="isOpen" class="wp-box__body"><slot /></div>
  </section>
</template>

<script>
/** WordPress-style collapsible metabox; open/closed state remembered per `storeKey`. */
export default {
  name: 'WpBox',
  props: { title: { type: String, required: true }, open: { type: Boolean, default: true }, storeKey: { type: String, default: '' } },
  data() {
    let isOpen = this.open
    try { const v = this.storeKey && localStorage.getItem('wpbox:' + this.storeKey); if (v) isOpen = v === '1' } catch (e) { /* ignore */ }
    return { isOpen }
  },
  methods: {
    toggle() {
      this.isOpen = !this.isOpen
      try { if (this.storeKey) localStorage.setItem('wpbox:' + this.storeKey, this.isOpen ? '1' : '0') } catch (e) { /* ignore */ }
    },
  },
}
</script>

<style scoped>
.wp-box { background: #fff; border: 1px solid #dcdcde; border-radius: 4px; margin-bottom: 16px; }
.wp-box__head { display: flex; align-items: center; gap: 8px; width: 100%; padding: 10px 14px; background: none; border: 0; border-bottom: 1px solid #f0f0f1; font-size: 14px; font-weight: 600; color: #1d2327; text-align: right; cursor: pointer; }
.is-closed .wp-box__head { border-bottom: 0; }
.wp-box__title { flex: 1; }
.wp-box__chev { color: #787c82; transition: transform .15s; }
.is-closed .wp-box__chev { transform: rotate(90deg); }
.wp-box__body { padding: 12px 14px; font-size: 13px; }
</style>
